export class LastStatusTransition {
  public id: number;
  public date: string; // ($date-time)
  public scanId: number;
  public contactId?: number;
  public statusId?: number;
  public comment?: string;
}
